
import {getLabel} from './Institution'
import {OPHTHALMOLOGY, userProvides} from "@/utils/Specialist";

export const getEventCancelReason = (str = '') => {

    switch(str){
        case 'another_institution':
            return `El ${getLabel('commons.client.singular').toLowerCase()} encontro hora en otro centro`
            break
        case 'cant_contact_client':
            return `No se pudo contactar al ${getLabel('commons.client.singular').toLowerCase()}`
            break
        default:
            return str
    }

}

export const getPhysicalExamName = () => {
    let name = 'Físicos'

    if(userProvides(OPHTHALMOLOGY)){
        name = 'Oftalmológicos'
    }

    return `Exámenes ${name}`

}

export const getPaymentType = (str = '') => {

    const options = {
        medical_voucher: 'Bono',
        private: 'Particular',
        free: 'Sin Costo'
    }

    return options[str]

}